/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_TrainerInputs */

const en_for_whom_trainer = /** @type {(inputs: For_Whom_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal trainer`)
};

const pl_for_whom_trainer = /** @type {(inputs: For_Whom_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener personalny`)
};

/**
* | output |
* | --- |
* | "Personal trainer" |
*
* @param {For_Whom_TrainerInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_trainer = /** @type {((inputs?: For_Whom_TrainerInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_TrainerInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_trainer(inputs)
	return en_for_whom_trainer(inputs)
});